import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { Message } from 'src/app/models/message';
import { Networks } from 'src/app/models/obs/networks';
import { Tematic } from 'src/app/models/obs/tematic';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { Tier1Service } from 'src/app/services/obs/tier1.service';
import { Tier1 } from 'src/app/models/obs/tier1';
import { NetworkService } from 'src/app/services/obs/network.service';
import { urlEndPoint } from 'src/app/common';

@Component({
  selector: 'app-networks',
  templateUrl: './networks.component.html',
  styleUrl: './networks.component.scss'
})
export class NetworksComponent implements OnInit {
  @ViewChild('searchInputRef', { static: false }) searchInputRef: ElementRef;
  @ViewChild('selectTematic', { static: false }) selectTematic: ElementRef;
  @ViewChild('selectTipo', { static: false }) selectTipo: ElementRef;

  originalObservers: Networks[] = [];
  observers: Networks[] = [];
  tematic: Tematic[] = [];
  msg: Message;
  t1: Tier1;
  URLObs: string = urlEndPoint;
  //Agregado
  currentPage: number = 1;
  itemsPerPage: number = 6;
  selectedTematic: string = '0';
  selectedTipo: string = '0';

  showResultsMessage: boolean = false;
  showNoResultsMessage: boolean = false;
  tipo: any[] = [
    { id: 1, name: 'Redes de Prospectiva' },
    { id: 2, name: 'Redes de Observatorios' }
  ];
  //
  constructor(
    private networkS: NetworkService,
    private t1S: Tier1Service,
    private http: HttpClient,
    private tematicService: TematicService,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.getInitialText();
    this.getTematics();
    this.getAllNetworks();
  }

  public getAllNetworks(): void {
    /* this.http.get("../../../assets/json/observers.json").subscribe((observers: Networks[]) => { */
    this.networkS.getAll().subscribe(
      (observers: any) => {
        const data = observers.data;
        this.originalObservers = data;
        this.observers = [...data];
/*         console.log("Data", data)
        console.log("Este es:", this.originalObservers)
        console.log(this.observers) */
        this.updateObserversWithTematicInfo();
      });
  }

  public getTematics() {
    this.tematicService.getAll().subscribe(
      res => { this.tematic = res['data']; },
      err => { this.msg = err; }
    );
  }

  getInitialText() {
    this.t1S.getOne(27).subscribe(
      res => {
        this.t1 = res['data'];
      },
      err => { this.msg = err; }
    );
  }

  //Buscador
  performSearch(keyword: string) {
    const lowerCaseSearchTerm = keyword.toLowerCase();
    this.selectedTematic = '0';
    this.selectedTipo = '0';
    if (lowerCaseSearchTerm === '') {
      this.observers = this.originalObservers;
      this.showResultsMessage = false;
      this.showNoResultsMessage = false;
      /* console.log(this.observers); */
    } else {
      this.observers = this.originalObservers.filter(obs =>
        obs.name.toLowerCase().includes(lowerCaseSearchTerm)
      );
      this.showResultsMessage = this.observers.length > 0;
      this.showNoResultsMessage = !this.showResultsMessage;
      /* console.log(this.observers); */
    }
    /* console.log(lowerCaseSearchTerm) */
    this.currentPage = 1;
    this.searchInputRef.nativeElement.value = '';
    this.renderer.setProperty(this.selectTematic.nativeElement, 'value', this.selectedTematic);
    this.renderer.setProperty(this.selectTipo.nativeElement, 'value', this.selectedTipo);
  }

  //Filtrar por tipo y tematica
  selectedTematicChanged(value: string) {
    this.selectedTematic = value;
    this.selectObservatorios();
    /* console.log("Tematica valor:" + this.selectedTematic) */
  }

  selectedTipoChanged(value: string) {
    this.selectedTipo = value;
    this.selectObservatorios();
    /* console.log("Tipo valor:" + this.selectedTipo) */
  }

  selectObservatorios() {
    const selectedTematicId = this.selectedTematic;
    const selectedTipo_name = this.selectedTipo;
    const tematicFilterApplied = selectedTematicId !== '0';
    const tipoFilterApplied = selectedTipo_name !== '0';

    if (tematicFilterApplied || tipoFilterApplied) {
      this.observers = this.originalObservers.filter(obs => {
        if (tematicFilterApplied && tipoFilterApplied) {
          return obs.idtematic.toString() === selectedTematicId && obs.type === selectedTipo_name;
        } else if (tematicFilterApplied) {
          return obs.idtematic.toString() === selectedTematicId;
        } else if (tipoFilterApplied) {
          return obs.type === selectedTipo_name;
        }
        return true; // No filters applied, include all
      }
      );
      if (this.observers.length > 0) {
        console.log("Se encontraron resultados")
      } else {
        console.log("No se econtraron resultados")
      }

      this.currentPage = 1;
      // Verificar si se encontraron resultados o no
      this.showResultsMessage = this.observers.length > 0;
      this.showNoResultsMessage = !this.showResultsMessage;
    } else {
      // No filters applied, show all
      this.observers = this.originalObservers;
      this.currentPage = 1;
      this.showResultsMessage = false;
      this.showNoResultsMessage = false;
    }
  }

  updateObserversWithTematicInfo() {
    this.observers.forEach(o => {
      this.tematic.forEach(t => {
        if (o.idtematic == t.id) {
          o.color = t.color;
          o.tematic = t.title;
        }
      });
    });
  }

  //PAGINADOR
  getPageNumbers(): number[] {
    const totalPages = Math.ceil(this.observers.length / this.itemsPerPage);
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  isPageActive(pageNumber: number): boolean {
    return pageNumber === this.currentPage;
  }

  changePage(pageNumber: number): void {
    this.currentPage = pageNumber;
  }

}
